import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';
import { useTranslation } from '@/store/languageStore';

export default function FuelDuplicateBadge({ company }: { company?: string | null }) {
  const { t } = useTranslation();
  const title = company
    ? t('fuel.duplicate.tooltipCompany', { company })
    : t('fuel.duplicate.tooltip');
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-amber-800"
      title={title}
    >
      <ExclamationTriangleIcon className="h-3.5 w-3.5" />
      <span className="text-[11px] font-semibold uppercase tracking-wide">{t('fuel.duplicate.badge')}</span>
    </span>
  );
}
